import { createAsyncThunk } from '@reduxjs/toolkit'
import { getCategoriesAndDocuments } from 'services/firebase';

export const categoriesArray = createAsyncThunk(
    // action type string
    'categories/getCategoriesArray',
    // callbackFn
    async() => {
        const categoriesArray = await getCategoriesAndDocuments();
        return categoriesArray
    }
)